import apiClientCreator from "@/helpers/api/request";

export default {
  methods: {
    async setCampaignsData(sector) {
      // if (
      //     this.getChartsViewBlocks[1] !== "questions"
      // ) {
      //     return;
      // }
      let rootPath = "";

      rootPath = `client/stats/multiselect/${sector}`;
      await apiClientCreator(rootPath)
        .get("", { params: this.queryObject })
        .then(res => {
          let hash = Math.floor(Math.random() * 10000) + 1;
          let chartData = {
            mainSector: this.sector,
            selectedTab: this.sector,
            valid: true,
            data: res.data,
            fromChart: false,
            tabsList: [],
            hash: hash
          };
          this.$store.commit("clients/setMultiSelectChartData", [
            chartData,
            this.sector
          ]);
        })
        .catch(err => {});
    },

    checkCampaignSector(sector, campaignId) {
      if (campaignId == 1) {
        switch (sector) {
          case "advertising":
            return true;
          case "keyword":
            return true;
          case "device":
            return true;
          case "placement":
            return true;
          default:
            return false;
        }
      } else if (campaignId == 2) {
        switch (sector) {
          case "click_type":
            return true;
          case "location":
            return true;
          default:
            return false;
        }
      }
    }
  }
};
